module.exports = __webpack_public_path__ + "img/202306_04.cab4ab3d.jpg";